const state = {
    count:0,
    sum  : 0,
    meetingInfo:{}

};



export  default state

